import React from 'react';

const toIsoDateTime = (value) => {
    const time = String(value || '').trim();
    if (!time) return '';
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})$/.test(time)) return time;

    const normalized = time.replace(/\//g, '-');
    const dateTime = normalized.replace(' ', 'T');
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(dateTime) ? `${dateTime}+08:00` : dateTime;
};

const formatDisplayTime = (value) => {
    const time = String(value || '').trim().replace(/\//g, '-');
    if (!time) return '';
    const [date, clock] = time.split(' ');
    if (!date || !clock) return time;
    const [y, m, d] = date.split('-');
    if (!y || !m || !d) return time;
    return `${y}年${m}月${d}日 ${clock}`;
};

const toTimestamp = (value) => {
    const iso = toIsoDateTime(value);
    if (!iso) return NaN;
    const ms = new Date(iso).getTime();
    return Number.isNaN(ms) ? NaN : Math.floor(ms / 1000);
};

const isSameTime = (a, b) => {
    const timeA = toTimestamp(a);
    const timeB = toTimestamp(b);
    return Number.isFinite(timeA) && Number.isFinite(timeB) && timeA === timeB;
};

const VisibleSeoTime = ({ publishTime, className, children }) => {
    const iso = toIsoDateTime(publishTime);
    if (!iso) return children ? <span className={className}>{children}</span> : null;

    return (
        <time itemProp="datePublished" dateTime={iso} className={className}>
            {children}
        </time>
    );
};

const HiddenSeoTime = ({ publishTime, updateTime, showHiddenPublish = false }) => {
    const showUpdate = updateTime && !isSameTime(publishTime, updateTime);

    return (
        <>
            {showHiddenPublish && publishTime ? (
                <time itemProp="datePublished" dateTime={toIsoDateTime(publishTime)}>
                    &nbsp; {formatDisplayTime(publishTime)}
                </time>
            ) : null}
            {showUpdate ? (
                <time itemProp="dateModified" dateTime={toIsoDateTime(updateTime)}>
                    &nbsp; 更新时间 {formatDisplayTime(updateTime)}
                </time>
            ) : null}
        </>
    );
};

export { toIsoDateTime, VisibleSeoTime };
export default HiddenSeoTime;
